import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AssignmentRssView } from '@app/pages/admin/assignment-rss';

@Component({
  selector: 'app-assignment-rss-cell',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './assignment-rss-cell.html',
  styleUrl: './assignment-rss-cell.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignmentRssCellComponent {
  readonly rss = input<AssignmentRssView | null>(null);
}
